import { useEffect, useState } from 'react'

/**
 * Id della sezione che attraversa il centro dello schermo, tra quelle indicate (indici con la voce attiva).
 * `ids` deve essere stabile (costante di modulo): cambiarlo ricollega l'osservatore.
 */
export function useActiveSection<T extends string>(ids: readonly T[]): T {
  const [active, setActive] = useState<T>(ids[0])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const current = entries.find((entry) => entry.isIntersecting)
        if (current) setActive(current.target.id as T)
      },
      { rootMargin: '-45% 0px -50% 0px' },
    )
    for (const id of ids) {
      const section = document.getElementById(id)
      if (section) observer.observe(section)
    }
    return () => observer.disconnect()
  }, [ids])

  return active
}
